import Vuex from "vuex";
import Vue from "vue";
import VueResource from "vue-resource";
import VueI18n from 'vue-i18n';
import { productFinderStore } from "@productfinder/store/productFinderStore";
import greentool from "@src/Resources/epim/Templates/Greentool/app/greentool";

export const greentoolInit = {
    init: () => {
        const greentoolShells = document.querySelectorAll('.greentool__container');

        if (greentoolShells.length > 0) {
            Vue.use(VueResource);
            Vue.use(VueI18n);
            Vue.use(Vuex);

            // Something is wrong with you if you want to have multiple on the same page
            const greentoolShell = greentoolShells[0];

            new Vue({
                store: productFinderStore,
                render: h => h(greentool, {
                    props: {}
                }),
                i18n: new VueI18n({
                    locale: 'all', // set locale
                    messages: {'all': Object.assign({}, window.jsI18N)} // set locale messages
                }),
            }).$mount(greentoolShell);
        }
    }
};
